// Module
var code = "<div layout=\"column\" class=\"full-height\"> <price-plan-bundle-table flex bundles=\"$ctrl.bundles\" refresh-list=\"$ctrl.refreshList()\"> </price-plan-bundle-table> <span flex ng-if=\"$ctrl.loading\"></span> <md-progress-linear ng-disabled=\"!$ctrl.loading\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-linear> </div>";
// Exports
export default code;